import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AdminAuthService from "../network routes/authHelper";
import { DEFAULT_MODE, mergeRules } from "../../config/auctionRules";

export const checkLoginStatus = createAsyncThunk(
  "admin/checkLoginStatus",
  async () => {
    const response = await AdminAuthService.getCurrentUser(
      localStorage.getItem("token")
    );
    return response;
  }
);

export const loginAdmin = createAsyncThunk("admin/logInAdmin", async (data) => {
  const response = await AdminAuthService.login(data);
  return response;
});

export const signupAdmin = createAsyncThunk(
  "admin/signupAdmin",
  async (data) => {
    const response = await AdminAuthService.signup(data);
    return response;
  }
);

export const startAuction = createAsyncThunk("admin/startAuction", async () => {
  const response = await AdminAuthService.startAuction();
  return response;
});

export const resetAuction = createAsyncThunk("admin/resetAuction", async () => {
  const response = await AdminAuthService.resetAuction();
  return response;
});

export const stopAuction = createAsyncThunk("admin/stopAuction", async (id) => {
  const response = await AdminAuthService.stopAuction(id);
  return response;
});

export const getSession = createAsyncThunk("admin/getSession", async () => {
  const response = await AdminAuthService.getSession();
  return response;
});

export const setAuctionMode = createAsyncThunk(
  "admin/setAuctionMode",
  async (auctionMode) => {
    const response = await AdminAuthService.setAuctionMode(auctionMode);
    return response;
  }
);

export const getAuctionRules = createAsyncThunk(
  "admin/getAuctionRules",
  async () => {
    const response = await AdminAuthService.getAuctionRules();
    return response;
  }
);

export const setAuctionRules = createAsyncThunk(
  "admin/setAuctionRules",
  async ({ auctionMode, rules }) => {
    const response = await AdminAuthService.setAuctionRules({
      auctionMode,
      rules,
    });
    return response;
  }
);

export const importWomenPlayers = createAsyncThunk(
  "admin/importWomenPlayers",
  async () => {
    const response = await AdminAuthService.importWomenPlayers();
    return response;
  }
);

export const getPlayerPool = createAsyncThunk(
  "admin/getPlayerPool",
  async () => {
    const response = await AdminAuthService.getPlayerPool();
    return response;
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    isLoggedIn: false,
    adminData: {},
    session: {},
    // { men: {total, indians, overseas}, women: {...} } source pool sizes.
    playerPool: {},
    // Effective rules per mode, and whether each has been customised.
    auctionRules: {},
    customRules: {},
    modeStatus: "idle",
    status: "idle", //loading;
    error: {},
  },
  reducers: {
    logout: (state, action) => {
      state.isLoggedIn = false;
      state.status = "error";
      state.adminData = {};
      localStorage.setItem("token", "");
    },
  },
  extraReducers: {
    [checkLoginStatus.pending]: (state, action) => {
      state.status = "Loading";
    },
    [checkLoginStatus.fulfilled]: (state, action) => {
      if (action.payload.statusCode === 200) {
        localStorage.setItem("token", action.payload.data.token);
        state.isLoggedIn = true;
        state.adminData = action.payload.data;
        state.status = "fulfilled";
      } else {
        localStorage.setItem("token", "");
        state.isLoggedIn = false;
        state.adminData = {};
        state.status = "error";
      }
    },
    [checkLoginStatus.rejected]: (state, action) => {
      state.error = action.error;
      state.status = "error";
    },
    [loginAdmin.fulfilled]: (state, action) => {
      if (action.payload.statusCode === 200) {
        // console.log(action.payload);
        localStorage.setItem("token", action.payload.data.token);
        state.status = "fulfilled";
        state.adminData = action.payload.data;
      } else {
        state.status = "error";
        localStorage.setItem("token", "");
        state.isLoggedIn = false;
        state.adminData = {};
      }
    },
    [loginAdmin.rejected]: (state, action) => {
      state.error = action.error;
      state.status = "error";
    },
    [startAuction.pending]: (state, action) => {
      state.status = "Loading";
    },
    [startAuction.fulfilled]: (state, action) => {
      if (action.payload.statusCode === 200) {
        state.session = action.payload.data;
        state.status = "fulfilled";
      } else {
        state.session = {};
        // state.status = "error";
      }
    },
    [startAuction.rejected]: (state, action) => {
      state.error = action.error;
      // state.status = "error";
    },
    [resetAuction.pending]: (state, action) => {
      state.status = "Loading";
    },
    [resetAuction.fulfilled]: (state, action) => {
      if (action.payload.statusCode === 200) {
        state.session = action.payload.data[0];
        state.status = "fulfilled";
      } else {
        state.session = {};
        // state.status = "error";
      }
    },
    [resetAuction.rejected]: (state, action) => {
      state.error = action.error;
      // state.status = "error";
    },
    [stopAuction.pending]: (state, action) => {
      // state.status = "Loading";
    },
    [stopAuction.fulfilled]: (state, action) => {
      if (action.payload.statusCode === 200) {
        state.session = {};
        // state.status = "fulfilled";
      } else {
        state.session = {};
        state.status = "error";
      }
    },
    [stopAuction.rejected]: (state, action) => {
      state.error = action.error;
      state.status = "error";
    },
    [getSession.pending]: (state, action) => {
      // state.status = "Loading";
    },
    [getSession.fulfilled]: (state, action) => {
      if (action.payload.statusCode === 200) {
        state.session = action.payload.data;
        // state.status = "fulfilled";
      } else if (action.payload.statusCode === 404) {
        state.session = {};
        // state.status = "fulfilled";
      } else {
        console.log(action.payload);
        state.session = {};
        // state.status = "error";
      }
    },
    [getSession.rejected]: (state, action) => {
      state.error = action.error;
      // state.status = "error";
    },
    [setAuctionMode.pending]: (state) => {
      state.modeStatus = "Loading";
    },
    [setAuctionMode.fulfilled]: (state, action) => {
      if (action.payload.statusCode === 200) {
        // Keep the cached admin doc in step so the toggle reflects the change
        // without a refetch.
        state.adminData = {
          ...state.adminData,
          auctionMode: action.payload.data.auctionMode,
        };
        if (state.session?._id) {
          state.session = {
            ...state.session,
            auctionMode: action.payload.data.auctionMode,
          };
        }
        state.modeStatus = "fulfilled";
      } else {
        state.modeStatus = "error";
      }
    },
    [setAuctionMode.rejected]: (state, action) => {
      state.error = action.error;
      state.modeStatus = "error";
    },
    [importWomenPlayers.pending]: (state) => {
      state.modeStatus = "Loading";
    },
    [importWomenPlayers.fulfilled]: (state, action) => {
      state.modeStatus =
        action.payload.statusCode === 200 ? "fulfilled" : "error";
    },
    [importWomenPlayers.rejected]: (state, action) => {
      state.error = action.error;
      state.modeStatus = "error";
    },
    [getAuctionRules.fulfilled]: (state, action) => {
      if (action.payload.statusCode === 200) {
        state.auctionRules = action.payload.data.rules;
        state.customRules = action.payload.data.custom;
      }
    },
    [setAuctionRules.pending]: (state) => {
      state.modeStatus = "Loading";
    },
    [setAuctionRules.fulfilled]: (state, action) => {
      if (action.payload.statusCode === 200) {
        const { auctionMode, rules, custom } = action.payload.data;
        state.auctionRules = { ...state.auctionRules, [auctionMode]: rules };
        state.customRules = { ...state.customRules, [auctionMode]: custom };
        state.modeStatus = "fulfilled";
      } else {
        state.modeStatus = "error";
      }
    },
    [setAuctionRules.rejected]: (state, action) => {
      state.error = action.error;
      state.modeStatus = "error";
    },
    [getPlayerPool.fulfilled]: (state, action) => {
      state.playerPool =
        action.payload.statusCode === 200 ? action.payload.data : {};
    },
  },
});

export const { logout } = adminSlice.actions;
export const selectAdmin = (state) => state.admin.adminData;
export const selectSession = (state) => state.admin.session;
export const selectStatus = (state) => state.admin.status;
export const selectIsLoggedIn = (state) => state.admin.isLoggedIn;
export const selectAuctionMode = (state) =>
  state.admin.adminData?.auctionMode || DEFAULT_MODE;
export const selectModeStatus = (state) => state.admin.modeStatus;
export const selectPlayerPool = (state) => state.admin.playerPool;
// Effective rules for the active mode, defaults included.
export const selectActiveRules = (state) =>
  mergeRules(
    state.admin.adminData?.auctionMode || DEFAULT_MODE,
    state.admin.auctionRules?.[state.admin.adminData?.auctionMode || DEFAULT_MODE]
  );
export const selectRulesAreCustom = (state) =>
  Boolean(state.admin.customRules?.[state.admin.adminData?.auctionMode || DEFAULT_MODE]);

export default adminSlice.reducer;
